// extracted by mini-css-extract-plugin
export var agreement = "style-module--agreement--GLTI+";
export var beTheChange = "style-module--beTheChange--ski+a";
export var bgWrapper = "style-module--bgWrapper--iavsJ";
export var contentWrapper = "style-module--contentWrapper--qvOhv";
export var details = "style-module--details--prwYZ";
export var formWrapper = "style-module--formWrapper--ZGPzj";
export var root = "style-module--root--7miOe";
export var textarea = "style-module--textarea--JDIkn";